export enum LiveStatusEvents {
  COLLECTION_ADDED = 'collection_added',
  COLLECTION_DELETED = 'collection_deleted',
  COLLECTION_CREATED_AND_SELECTED = 'collection_created_and_selected',
  COLLECTIONS_LOADED = 'collections_loaded',
}

export const UpdateLiveStatusTranslations = {
  [LiveStatusEvents.COLLECTION_ADDED]: 'accessibility.productAddedToCollection',
  [LiveStatusEvents.COLLECTION_DELETED]:
    'accessibility.productRemovedFromCollection',
  [LiveStatusEvents.COLLECTION_CREATED_AND_SELECTED]:
    'accessibility.collectionCreatedandSelected',
  [LiveStatusEvents.COLLECTIONS_LOADED]: 'accessibility.collectionsLoaded',
};

export type LiveStatusEvent = {
  eventName: LiveStatusEvents;
  data:
    | {
        collectionName?: string;
        totalCollections?: number;
      }
    | undefined;
};

export enum CollectionsAnnouncement {
  LOADED = 'loaded',
  NO_COLLECTIONS = 'noCollections',
  REMOVED = 'removed',
}
